import React from "react";
import { FaWandMagicSparkles } from "react-icons/fa6";

// The Sandbox AI mark. Distinct from the Whistle AI whistle mark — both FABs
// stack on /sandbox. react-icons renders at 1em in currentColor, so font-size
// controls it, like WhistleIcon.
const SandboxIcon: React.FC<{ className?: string }> = ({ className }) => (
  <FaWandMagicSparkles className={className} aria-hidden="true" />
);

export default SandboxIcon;
